// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.edit_dashboard__XFUIy {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.edit_dashboardContain__yQ2cD {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.edit_bodythemedark__0LHjt .edit_dashboardContain__yQ2cD,
.edit_bodythemedark__0LHjt .edit_dashboard__XFUIy,
.edit_bodythemedark__0LHjt .edit_cont2__FVTrO {
  background-Color: #0f1824;
}

.edit_top_header__bdkVV .edit_top_header_inner__bXGSL {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.edit_cont2__FVTrO {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.edit_subLink__-5pVR svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.edit_footer__HLOZE {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.edit_bodythemelight__q5mLJ {
  background-color: #fff;
  padding-top: 90px;
}

.edit_bodythemedark__0LHjt {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.edit_headerthemelight__WUo4J {
  background-color: #fff;
}

.edit_headerthemedark__nV12j {
  background-color: #132337;
}

.edit_top_header__bdkVV {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.edit_menuthemelight__UlCgS {
  background-color: #fff;
}

.edit_menuthemedark__c5mml {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.edit_menulinklight__v\\+chl span {
  color: #666666 !important;
}

.edit_menulinklight__v\\+chl a {
  color: #CBCBCB !important;
}

.edit_menulinklight__v\\+chl:hover span, .edit_menulinklight__v\\+chl:hover a {
  color: #fff !important;
}

.edit_menulinkdarkSelected__ySgsR {
  background-color: #1c2e45;
  color: #3b82f6;
}

.edit_menuthemelight__UlCgS .edit_menulinklightSelected__nwgnU {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.edit_menulinkdark__e\\+3iY {
  color: #92afd3 !important;
}

.edit_menulinklight__v\\+chl:hover {
  color: #fff !important;
  background-color: #131F43;
}

.edit_menulinklight__v\\+chl .edit_sub_arrow__IsM39 svg path {
  stroke: #CBCBCB !important;
}

.edit_menulinklight__v\\+chl:hover .edit_sub_arrow__IsM39 svg path {
  stroke: #fff !important;
}

.edit_menulinkdark__e\\+3iY .edit_sub_arrow__IsM39 svg path {
  stroke: #92afd3 !important;
}

.edit_menulinkdark__e\\+3iY:hover .edit_sub_arrow__IsM39 svg path {
  stroke: #fff !important;
}

.edit_menulinkdark__e\\+3iY:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.edit_headinglight__RHQVI {
  color: #60677e;
}

.edit_headingdark__Adcis {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.edit_searchboxlight__2HGJ9 {
  background-color: #fff;
  border: none;
}

.edit_searchboxdark__4vEKI {
  background-color: #132337;
  color: #fff;
  border: none;
}

.edit_searchboxdark__4vEKI::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.edit_tableheadlight__bJyAN {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.edit_tableheadlight__bJyAN th {
  color: #fff;
}

thead .edit_tableheadlight__bJyAN th:first-child,
thead .edit_tableheaddark__q0qCR th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .edit_tableheadlight__bJyAN th:last-child,
thead .edit_tableheaddark__q0qCR th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.edit_table__-qogP.edit_table-borderless__L48Ri {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.edit_tableheaddark__q0qCR {
  background-color: #132337;
  color: #fff;
}

.edit_table-borderless__L48Ri tr:nth-child(even) {
  background-color: #F9FAFB;
}

.edit_table-borderless__L48Ri .edit_left-section__DvxgR {
  padding-top: 10px;
}

.edit_tablebodylight__zzua1 td,
.edit_tablebodydark__Asv9G td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.edit_tablebodylight__zzua1 {
  background-color: #fff;
}
.edit_tablebodylight__zzua1:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.edit_tablebodydark__Asv9G {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.edit_tablebodydark__Asv9G:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.edit_paginationlight__UsHRc {
  color: #60677e !important;
  font-size: 13px !important;
}

.edit_paginationdark__Ve4s5 {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.edit_formthemelight__1srUw {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.edit_formthemedark__NIUi5 {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.edit_formthemedark__NIUi5 ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.edit_viewformlight__z8N9A {
  background-color: #f3f6f9;
}

.edit_permissionboxlight__zacXR {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.edit_permissionboxdark__kCVOv {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.edit_errormsgclr__vqhkc {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.edit_graphclrlight__17YTi {
  background-color: #fff;
}

.edit_graphclrdark__GQK9A {
  background-color: #132337;
}

/* 
Counter theme
*/
#edit_card1bglight__uISux {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#edit_card1bgdark__s5ViH {
  background: #392f28;
}

#edit_card2bglight__qWy0- {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#edit_card2bgdark__9eIJP {
  background: #1c3238;
}

#edit_card3bglight__i8MQs {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#edit_card3bgdark__UI-WU {
  background: #3a2434;
}

#edit_card4bglight__MDS-U {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#edit_card4bgdark__HPvid {
  background: #2f264f;
}

#edit_card1bgdark__s5ViH a, #edit_card1bgdark__s5ViH p,
#edit_card2bgdark__9eIJP a, #edit_card2bgdark__9eIJP p,
#edit_card3bgdark__UI-WU a, #edit_card3bgdark__UI-WU p,
#edit_card4bgdark__HPvid a, #edit_card4bgdark__HPvid p {
  color: #fff;
}

/* 
Action button theme
*/
.edit_actionbtnlight__wqx85 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.edit_actionbtnlight__wqx85:hover {
  cursor: pointer;
}

.edit_actionbtndark__DIeWX {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.edit_profiledropdownlight__vMEbz {
  background-color: #fff;
}

.edit_profiledropdowndark__hamPR {
  background-color: #151521;
}

.edit_settingsection__ulggD #edit_addform__VzIZa.edit_formthemedark__NIUi5 .edit_savebtn__CSqa6 {
  background-color: #3b82f6;
  color: #fff;
}

#edit_addform__VzIZa.edit_formthemedark__NIUi5 .edit_savebtn__CSqa6 {
  background-color: #3b82f6;
  color: #fff;
}

.edit_profile_conatiner__SA5tk {
  border-radius: 5px !important;
}

.edit_bodythemedark__0LHjt .edit_ag-theme-alpine__Dnnj7 .edit_ag-row__tO\\+na {
  background: #000 !important;
}

.edit_bodythemedark__0LHjt .edit_formbtn__NVKT0 {
  background-color: #3b82f6;
}

.edit_bodythemedark__0LHjt .edit_formbtn__NVKT0:hover {
  background-color: #2563eb;
}

.edit_bodythemedark__0LHjt .edit_resetbtn__DV\\+5m {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.edit_bodythemedark__0LHjt .edit_resetbtn__DV\\+5m:hover {
  background-color: #3b82f6;
}

.edit_headingdark__Adcis span {
  background-color: #132337;
}

.edit_resetbtn__DV\\+5m {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.edit_resetbtn__DV\\+5m:hover,
.edit_resetbtn__DV\\+5m:active,
.edit_resetbtn__DV\\+5m:focus {
  background-color: #131F43;
  color: #fff;
}

.edit_addBtn__fWQ-T {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.edit_addbtnlight__VhnTB {
  background-color: #38A169;
}

.edit_addbtndark__\\+vSZY {
  background-color: #3b82f6;
}

.edit_addbtndark__\\+vSZY:hover {
  background-color: #2563eb;
}

.edit_formthemedark__NIUi5 label {
  color: #92afd3;
}

.edit_addBtn__fWQ-T svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.edit_addBtn__fWQ-T:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.edit_cust_addBtn__ZhtvT.edit_addBtn__fWQ-T svg {
  top: 2px;
}

.edit_deleteBtn__avVJ9 {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.edit_deleteBtn__avVJ9 {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.edit_deleteBtn__avVJ9:active, .edit_deleteBtn__avVJ9:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.edit_deleteBtn__avVJ9 svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.edit_deleteBtn__avVJ9:hover,
.edit_deleteBtn__avVJ9:active,
.edit_deleteBtn__avVJ9:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.edit_confirmBtn__xvKFZ {
  background-color: #131F43;
}

.edit_confirmBtn__xvKFZ:hover,
.edit_confirmBtn__xvKFZ:active,
.edit_confirmBtn__xvKFZ:focus {
  background-color: #131F43;
}

.edit_confirmBtn__xvKFZ svg {
  top: 0;
}

.edit_delPopContainer__9mlmD .edit_modal-body__i4h\\+v {
  padding: 25px;
  text-align: center;
}

.edit_delPopContainer__9mlmD .edit_delet_icon__Ksaf5 {
  margin-bottom: 11px;
}

.edit_delPopContainer__9mlmD p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.edit_arrowback__M6cUh svg {
  fill: #000;
}

.edit_bodythemedark__0LHjt .edit_arrowback__M6cUh {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.edit_bodythemedark__0LHjt .edit_arrowback__M6cUh svg {
  fill: #3b82f6;
}

.edit_bodythemedark__0LHjt .edit_drpdwn_btn__GvA4W {
  background-color: #132337;
}

.edit_bodythemedark__0LHjt .edit_empname__X95KO {
  color: #92afd3 !important;
}

.edit_bodythemedark__0LHjt .edit_navitemli__KOZiS a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.edit_bodythemedark__0LHjt .edit_tabnavli__\\+V862 a.edit_settingsgeneral__oIHHr,
.edit_bodythemedark__0LHjt .edit_tabnavli__\\+V862 a.edit_settingslinks__iqJ3D:hover {
  background-color: #3b82f6;
  color: #fff;
}

.edit_bodythemedark__0LHjt .edit_tabnavli__\\+V862 a.edit_settingslinks__iqJ3D {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.edit_headerthemedark__nV12j .edit_dropdown_menu_contain__DiFwP {
  background-color: #1c2e45;
  color: #fff;
}

.edit_headerthemedark__nV12j .edit_dropdown_menu_contain__DiFwP ul li a,
.edit_headerthemedark__nV12j .edit_dropdown_menu_contain__DiFwP .edit_dropdown_item__GKRhp,
.edit_headerthemedark__nV12j .edit_dropdown_menu_contain__DiFwP .edit_dropdown_item__GKRhp h5 {
  color: #fff;
}

.edit_headerthemedark__nV12j .edit_dropdown_menu_contain__DiFwP ul li a:hover,
.edit_headerthemedark__nV12j .edit_dropdown_menu_contain__DiFwP .edit_dropdown_item__GKRhp:hover {
  background-color: #132337;
  color: #fff;
}

.edit_dropdown_item__GKRhp:active {
  background-color: #F5F6FA;
}

.edit_profile_arrrow_dwn__obVLo {
  stroke: #132337;
}

.edit_headerthemedark__nV12j .edit_profile_arrrow_dwn__obVLo {
  stroke: #fff;
}

.edit_dateinputbox1__--VcR input,
.edit_dateinputbox1__--VcR span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .edit_tableheadlight__bJyAN th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .edit_dashboard__XFUIy {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .edit_cont2__FVTrO {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .edit_sectionright__RFXF1 {
    float: unset !important;
  }
  .edit_dashboard__XFUIy {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .edit_cont2__FVTrO {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .edit_bodythemelight__q5mLJ, .edit_bodythemedark__0LHjt {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .edit_exer_modal_contain__roWXG .edit_modal-dialog__8nwZJ {
    max-width: 1055px;
  }
  .edit_delPopContainer__9mlmD .edit_modal-dialog__8nwZJ {
    max-width: 350px;
  }
}
#edit_addform__VzIZa {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
}
#edit_addform__VzIZa .edit_permission_title__2o43i {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
#edit_addform__VzIZa #edit_addheading__m\\+O2r {
  font-size: 14px;
  margin-bottom: 0px;
  margin-left: 5px;
}
#edit_addform__VzIZa .edit_inputbox__1Vzn\\+ {
  padding: 4px 5px 8px 10px;
  border-radius: 5px;
  width: 100%;
  border: 1px solid #ced4da;
  color: #1d1d1d;
  font-size: 14px;
}
#edit_addform__VzIZa .edit_inputbox1__Sdh2j {
  padding: 4px 5px 8px 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #0f1824;
  color: #fff;
}
#edit_addform__VzIZa .edit_formlabel__5oDNG {
  font-size: 14px;
}
#edit_addform__VzIZa .edit_formbtn__NVKT0 {
  background-color: #131F43;
  color: white;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
}
#edit_addform__VzIZa .edit_formbtn__NVKT0:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
#edit_addform__VzIZa .edit_arrowback__M6cUh {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #39979d;
  cursor: pointer;
  border-radius: 3px;
}
#edit_addform__VzIZa .edit_arrowback__M6cUh:hover {
  background-color: #39979d;
  color: #fff;
}
#edit_addform__VzIZa ::placeholder {
  font-size: 12px;
}
#edit_addform__VzIZa ul {
  padding-left: 0px;
  display: flex;
  margin-bottom: 0;
}
#edit_addform__VzIZa ul li {
  list-style: none;
  width: 150px;
}
#edit_addform__VzIZa .edit_selectlabel__679jd {
  margin-left: 5px;
  font-size: 14px;
  text-transform: capitalize;
  vertical-align: middle;
}
#edit_addform__VzIZa #edit_permissionbox__ZXNKa {
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
}

.edit_bodythemedark__0LHjt .edit_formlabel__5oDNG {
  color: #fff !important;
}

.edit_formthemedark__NIUi5 input[type=checkbox i] {
  accent-color: #3b82f6 !important;
}

@media only screen and (max-width: 878px) {
  #edit_addform__VzIZa ul {
    display: list-item !important;
    list-style: none;
  }
}
@media only screen and (max-width: 600px) {
  #edit_dashboardcont2__\\+ULH1 {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/roles/edit.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAmDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,2BAAA;EACA,gBAAA;ACzEF;;AD2EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACxEF;;AD0EA;;;EAGE,yBAlEoB;ACLtB;;ADyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACtEF;;ADyEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAzHO;EA0HP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACpEF;;AD0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACvEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBAjGY;ACwBd;;AD4EA;;CAAA;AAGA;EACE,sBAxGY;EAyGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAvHgB;EAwHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBApHY;AC4Cd;;AD2EA;EACE,yBAnIgB;AC2DlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAxIY;ACiEd;;ADyEA;EACE,yBAtJgB;ACgFlB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAvKsB;EAwKtB,cAlLkB;AC4GpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAlNc;AC6IhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBA3Nc;ACsJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBA1MsB;EA2MtB,WAlMY;AC6Hd;;ADwEA;;CAAA;AAGA;EACE,cAtMe;ACiIjB;;ADwEA;EACE,cA1Me;ACqIjB;;ADwEA;;CAAA;AAGA;EACE,sBApNY;EAqNZ,YAAA;ACrEF;;ADwEA;EACE,yBApOgB;EAqOhB,WA1NY;EA2NZ,YAAA;ACrEF;;ADuEA;EACE,cA3Ne;ACuJjB;;ADuEA;;CAAA;AAGA;EACE,yBAnRc;EAoRd,8BAAA;ACpEF;;ADsEA;EACE,WAzOY;ACsKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAvPkB;EAwPlB,WAhQY;ACkMd;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBA9QY;ACoNd;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cApRe;AC0NjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA/SY;EAgTZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBA5SkB;EA6SlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAtTa;AC6PjB;;AD8DA;;CAAA;AAGA;EACE,yBArUgB;AC0QlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBApVoB;EAqVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAxVY;AC8Rd;;AD6DA;EACE,yBApVkB;AC0RpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBArWY;AC0Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA9WY;ACmTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAvXY;AC4Td;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAhYY;ACqUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WA3YY;ACgVd;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cArZe;AC4VjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBAzbkB;EA0blB,WAzaY;AC+Wd;;AD4DA;EACE,yBA7bkB;EA8blB,WA7aY;ACoXd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBA1ckB;ACiZpB;;AD4DA;EACE,yBA7cwB;ACoZ1B;;AD4DA;EACE,WAjcY;EAkcZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAxdkB;AC+ZpB;;AD6DA;EACE,yBAvdgB;AC6ZlB;;AD6DA;EACE,eAAA;EACA,gBArgBc;EAsgBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAngBc;EAogBd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAzgBc;EA0gBd,WA5dY;ACmad;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WAleY;EAmeZ,yBA9fY;EA+fZ,YAAA;EACA,eAAA;EACA,gBA1hBc;ACiehB;;AD4DA;EACE,yBArgBY;AC4cd;;AD2DA;EACE,yBA9fkB;ACscpB;;AD0DA;EACE,yBAhgBwB;ACyc1B;;AD0DA;EACE,cAtgBiB;AC+cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA/fY;EAggBZ,yBA3hBY;EA4hBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA/hBW;EAgiBX,WA5gBY;EA6gBZ,eAAA;EACA,gBAlkBc;EAmkBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBAziBW;EA0iBX,WAthBY;EAuhBZ,eAAA;EACA,gBA5kBc;EA6kBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA/jBW;EAgkBX,WA5iBY;EA6iBZ,YAAA;ACxDF;;AD2DA;EACE,yBA/lBc;ACuiBhB;;AD2DA;;;EAGE,yBArmBc;AC6iBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCAnmBc;EAomBd,cAxmBkB;AC8iBpB;;AD6DA;EACE,aA5mBkB;ACkjBpB;;AD6DA;EACE,yBAxmBgB;AC8iBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAvmBY;AC6iBd;;AD6DA;;EAEE,yBA7nBkB;EA8nBlB,WA7mBY;ACmjBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlnBY;ACyjBd;;AD4DA;EACE,yBA/nBsB;EAgoBtB,WAvnBY;AC8jBd;;AD4DA;;;EAGE,WA7nBY;ACokBd;;AD4DA;;EAEE,yBA7oBgB;EA8oBhB,WAnoBY;AC0kBd;;AD4DA;EACE,yBAtrBO;AC6nBT;;AD4DA;EACE,eAtpBgB;AC6lBlB;;AD4DA;EACE,YA/oBY;ACslBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AAzsBA;EAEI,WAAA;EACA,kBAAA;EACA,gBAAA;AA0sBJ;AAxsBI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AA0sBR;AAtsBI;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;AAwsBR;AArsBI;EACI,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,cDqCM;ECpCN,eAAA;AAusBR;AArsBI;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDkBc;ECjBd,WD2BM;AC4qBd;AArsBI;EAEI,eAAA;AAssBR;AApsBI;EACI,yBDiCW;EChCX,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAssBR;AApsBQ;EACI,2CDyBS;AC6qBrB;AAnsBI;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAqsBR;AAnsBU;EACE,yBAAA;EACA,WAAA;AAqsBZ;AAjsBI;EACI,eAAA;AAmsBR;AA/rBI;EACI,iBAAA;EACA,aAAA;EACA,gBAAA;AAisBR;AA/rBU;EACI,gBAAA;EACA,YAAA;AAisBd;AA7rBM;EACI,gBAAA;EAEA,eAAA;EACA,0BAAA;EACA,sBAAA;AA8rBV;AA3rBI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AA6rBR;;AAxrBA;EACI,sBAAA;AA2rBJ;;AAxrBA;EACI,gCAAA;AA2rBJ;;AAvrBE;EAEM;IACI,6BAAA;IACA,gBAAA;EAyrBV;AACF;AAprBE;EACE;IACI,wBD7BI;IC8BJ,UD7BG;IC8BH,kBAAA;IACA,aDrCW;EC2tBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #DBEAFE;  \n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #D1FAE5;  \n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FEF3C7;  \n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #E9D5FF; \n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon1-color: #3B82F6;  \n$cardIcon2-color: #10B981;  \n$cardIcon3-color: #F59E0B;  \n$cardIcon4-color: #8B5CF6;  \n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 30px;\n\n    .permission_title{\n        display: flex;\n        align-items: center;\n        margin-bottom: 10px;\n    }\n\n\n    #addheading{\n        font-size: 14px;\n        margin-bottom: 0px;\n        margin-left: 5px;\n    }\n\n    .inputbox{\n        padding: 4px 5px 8px 10px;\n        border-radius: 5px;\n        width: 100%;\n        border: 1px solid #ced4da;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .inputbox1{\n        padding: 4px 5px 8px 10px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkTheme_darkBlue;\n        color: $white-color;         \n    }\n    .formlabel{\n         \n        font-size: 14px;\n    }\n    .formbtn{\n        background-color: $primary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n\n        &:hover{\n            background-color: $secondary-btncolor;\n        }\n    }\n    .arrowback{\n        float: right;\n        background-color: #dde2eb;\n        padding: 10px;\n        color: #39979d;\n        cursor: pointer;\n        border-radius: 3px;\n\n          &:hover{\n            background-color: #39979d;\n            color: #fff;\n          }\n      }\n    \n    ::placeholder{\n        font-size: 12px;\n    }\n\n    \n    ul{\n        padding-left: 0px;\n        display: flex;\n        margin-bottom: 0;\n\n          li{\n              list-style: none;\n              width: 150px;\n          }\n      } \n  \n      .selectlabel{\n          margin-left: 5px;\n           \n          font-size: 14px;\n          text-transform: capitalize;\n          vertical-align: middle;\n      }\n\n    #permissionbox{\n        padding: 10px;\n        margin-bottom: 20px;\n        border-radius: 5px;\n    }\n\n  }\n  \n.bodythemedark .formlabel {\n    color: $white-color !important;\n}\n\n.formthemedark input[type='checkbox' i] {\n    accent-color: $dark-active-blue !important;\n}\n\n\n  @media only screen and (max-width: 878px) {\n    #addform{\n        ul {\n            display: list-item !important;\n            list-style: none;\n        }\n    }\n  }\n\n\n  @media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `edit_dashboard__XFUIy`,
	"dashboardContain": `edit_dashboardContain__yQ2cD`,
	"bodythemedark": `edit_bodythemedark__0LHjt`,
	"cont2": `edit_cont2__FVTrO`,
	"top_header": `edit_top_header__bdkVV`,
	"top_header_inner": `edit_top_header_inner__bXGSL`,
	"subLink": `edit_subLink__-5pVR`,
	"footer": `edit_footer__HLOZE`,
	"bodythemelight": `edit_bodythemelight__q5mLJ`,
	"headerthemelight": `edit_headerthemelight__WUo4J`,
	"headerthemedark": `edit_headerthemedark__nV12j`,
	"menuthemelight": `edit_menuthemelight__UlCgS`,
	"menuthemedark": `edit_menuthemedark__c5mml`,
	"menulinklight": `edit_menulinklight__v+chl`,
	"menulinkdarkSelected": `edit_menulinkdarkSelected__ySgsR`,
	"menulinklightSelected": `edit_menulinklightSelected__nwgnU`,
	"menulinkdark": `edit_menulinkdark__e+3iY`,
	"sub_arrow": `edit_sub_arrow__IsM39`,
	"headinglight": `edit_headinglight__RHQVI`,
	"headingdark": `edit_headingdark__Adcis`,
	"searchboxlight": `edit_searchboxlight__2HGJ9`,
	"searchboxdark": `edit_searchboxdark__4vEKI`,
	"tableheadlight": `edit_tableheadlight__bJyAN`,
	"tableheaddark": `edit_tableheaddark__q0qCR`,
	"table": `edit_table__-qogP`,
	"table-borderless": `edit_table-borderless__L48Ri`,
	"left-section": `edit_left-section__DvxgR`,
	"tablebodylight": `edit_tablebodylight__zzua1`,
	"tablebodydark": `edit_tablebodydark__Asv9G`,
	"paginationlight": `edit_paginationlight__UsHRc`,
	"paginationdark": `edit_paginationdark__Ve4s5`,
	"formthemelight": `edit_formthemelight__1srUw`,
	"formthemedark": `edit_formthemedark__NIUi5`,
	"viewformlight": `edit_viewformlight__z8N9A`,
	"permissionboxlight": `edit_permissionboxlight__zacXR`,
	"permissionboxdark": `edit_permissionboxdark__kCVOv`,
	"errormsgclr": `edit_errormsgclr__vqhkc`,
	"graphclrlight": `edit_graphclrlight__17YTi`,
	"graphclrdark": `edit_graphclrdark__GQK9A`,
	"card1bglight": `edit_card1bglight__uISux`,
	"card1bgdark": `edit_card1bgdark__s5ViH`,
	"card2bglight": `edit_card2bglight__qWy0-`,
	"card2bgdark": `edit_card2bgdark__9eIJP`,
	"card3bglight": `edit_card3bglight__i8MQs`,
	"card3bgdark": `edit_card3bgdark__UI-WU`,
	"card4bglight": `edit_card4bglight__MDS-U`,
	"card4bgdark": `edit_card4bgdark__HPvid`,
	"actionbtnlight": `edit_actionbtnlight__wqx85`,
	"actionbtndark": `edit_actionbtndark__DIeWX`,
	"profiledropdownlight": `edit_profiledropdownlight__vMEbz`,
	"profiledropdowndark": `edit_profiledropdowndark__hamPR`,
	"settingsection": `edit_settingsection__ulggD`,
	"addform": `edit_addform__VzIZa`,
	"savebtn": `edit_savebtn__CSqa6`,
	"profile_conatiner": `edit_profile_conatiner__SA5tk`,
	"ag-theme-alpine": `edit_ag-theme-alpine__Dnnj7`,
	"ag-row": `edit_ag-row__tO+na`,
	"formbtn": `edit_formbtn__NVKT0`,
	"resetbtn": `edit_resetbtn__DV+5m`,
	"addBtn": `edit_addBtn__fWQ-T`,
	"addbtnlight": `edit_addbtnlight__VhnTB`,
	"addbtndark": `edit_addbtndark__+vSZY`,
	"cust_addBtn": `edit_cust_addBtn__ZhtvT`,
	"deleteBtn": `edit_deleteBtn__avVJ9`,
	"confirmBtn": `edit_confirmBtn__xvKFZ`,
	"delPopContainer": `edit_delPopContainer__9mlmD`,
	"modal-body": `edit_modal-body__i4h+v`,
	"delet_icon": `edit_delet_icon__Ksaf5`,
	"arrowback": `edit_arrowback__M6cUh`,
	"drpdwn_btn": `edit_drpdwn_btn__GvA4W`,
	"empname": `edit_empname__X95KO`,
	"navitemli": `edit_navitemli__KOZiS`,
	"tabnavli": `edit_tabnavli__+V862`,
	"settingsgeneral": `edit_settingsgeneral__oIHHr`,
	"settingslinks": `edit_settingslinks__iqJ3D`,
	"dropdown_menu_contain": `edit_dropdown_menu_contain__DiFwP`,
	"dropdown_item": `edit_dropdown_item__GKRhp`,
	"profile_arrrow_dwn": `edit_profile_arrrow_dwn__obVLo`,
	"dateinputbox1": `edit_dateinputbox1__--VcR`,
	"sectionright": `edit_sectionright__RFXF1`,
	"exer_modal_contain": `edit_exer_modal_contain__roWXG`,
	"modal-dialog": `edit_modal-dialog__8nwZJ`,
	"permission_title": `edit_permission_title__2o43i`,
	"addheading": `edit_addheading__m+O2r`,
	"inputbox": `edit_inputbox__1Vzn+`,
	"inputbox1": `edit_inputbox1__Sdh2j`,
	"formlabel": `edit_formlabel__5oDNG`,
	"selectlabel": `edit_selectlabel__679jd`,
	"permissionbox": `edit_permissionbox__ZXNKa`,
	"dashboardcont2": `edit_dashboardcont2__+ULH1`
};
export default ___CSS_LOADER_EXPORT___;
